import * as types from './mutation-types'

const namespaced = true

const initialState = {
    list: [],
    dates: [],
    currentDate: {
        senate: null,
        house: null,
    },
    lastModelUpdate: null,
    senateMeanSeat: "",
    houseMeanSeat: "",
}

const mutations = {
    [types.PUT_AGGREGATE_MODELS](state, models) {
        state.list = models
    },
    [types.SET_DATES](state, dates) {
        state.dates = dates
    },
    [types.SET_CURRENT_DATE](state, { date, chamber }) {
        state.currentDate[chamber] = date
    },
    [types.PUT_LAST_MODEL_UPDATE](state, lastModelUpdate) {
        state.lastModelUpdate = lastModelUpdate;
    },
    [types.PUT_SENATE_MEAN_SEAT](state, senateMeanSeat) {
        state.senateMeanSeat = senateMeanSeat;
    },
    [types.PUT_HOUSE_MEAN_SEAT](state, houseMeanSeat) {
        state.houseMeanSeat = houseMeanSeat;
    },
}

const actions = {
    list: ({ commit }) => (
        fetch("https://forecasting-data.decisiondeskhq.com/2022/prod/aggregate_models.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status);
                }

                return response.json();
            })
            .then((data) => {
                const lastModelUpdate = data.find(d => d.lastUpdated);
                if (lastModelUpdate.lastUpdated) {
                    commit(types.PUT_LAST_MODEL_UPDATE, lastModelUpdate.lastUpdated);
                    commit(types.PUT_SENATE_MEAN_SEAT, lastModelUpdate.senateMeanSeat);
                    commit(types.PUT_HOUSE_MEAN_SEAT, lastModelUpdate.houseMeanSeat);
                }

                const models = data
                commit(types.PUT_AGGREGATE_MODELS, data)

                const senateDates = models
                    .filter((m) => m.chamber === "SENATE")
                    .map((m) => m.date)
                    .sort((a, b) => a.localeCompare(b))
                    .reverse();
                const houseDates = models
                    .filter((m) => m.chamber === "HOUSE")
                    .map((m) => m.date)
                    .sort((a, b) => a.localeCompare(b))
                    .reverse();
                
                const currentSenateDate = senateDates[0];
                const currentHouseDate = houseDates[0];

                // const dates = [...senateDates, ...houseDates];
                const dates = senateDates;
                commit(types.SET_DATES, dates);
                commit(types.SET_CURRENT_DATE, { date: currentSenateDate, chamber: "senate"});
                commit(types.SET_CURRENT_DATE, { date: currentHouseDate, chamber: "house" });
                return models
            })
            .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
            })
    )
}

const getters = {
    list(state) {
        return state.list
    },
    dates(state) {
        return state.dates
    },
    currentDate: (state) => (chamber) => {
        return state.currentDate[chamber]
    },
    lastModelUpdate(state) {
        return state.lastModelUpdate;
    },
    senateMeanSeat(state) {
        return state.senateMeanSeat;
    },
    houseMeanSeat(state) {
        return state.houseMeanSeat;
    },
}

export default {
    namespaced,
    state: initialState,
    mutations,
    actions,
    getters
}
